import { render, staticRenderFns } from "./ArtistConfirm.vue?vue&type=template&id=8510b24c&"
import script from "./ArtistConfirm.vue?vue&type=script&lang=js&"
export * from "./ArtistConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports